// extracted by mini-css-extract-plugin
module.exports = {"container":"DynamicFlowApp_container__fjQJ6","sidebarContainer":"DynamicFlowApp_sidebarContainer__8AmUq","site-main":"DynamicFlowApp_site-main__SkqET"};